var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",class:_vm.classes,style:(`${_vm.customStyle} width: ${_vm.newPercentage}%;`),attrs:{"aria-valuemax":"100"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }